import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { combo } from 'core';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'ui/pages/hooks';

export const useComboApplicationWrapper = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();

  useEffect(() => {
    if (history.location.pathname === '/combo' && query.get('q')) {
      dispatch(combo.actions.comboFetch.request());
    }
  }, [history.location.pathname, query.get('q')]);
};
